var React = require('react');

class SimpleSampleInput extends React.Component {

    constructor() {
        super();
        this.remove = this.remove.bind(this);
        this.changeSelection = this.changeSelection.bind(this);
        this.options = this.options.bind(this);
        this.form_input = this.form_input.bind(this);
    }

    remove() {
        this.props.removeSample(this.props.index);
    }

    changeSelection(event) {
        this.setState({disabled: false})
        this.props.chooseSample(this.props.index, event.target.value);
    }

    form_input(){
        if(this.props.sample) {
            return (<input hidden name={`${this.props.input_name}[]`} type="checkbox" value={this.props.sample} checked="checked" />);
        }
    }


    options() {
        if (this.props.options.length > 0) {
            return (
                <select id={`${this.props.input_name}-${this.props.index}`}
                        onChange={this.changeSelection}
                        value={this.props.sample}
                >
                    {
                        this.props.options.map((option)=> {
                            return (<option value={option.id}>{option.name}</option>)
                        })
                    }
                </select>
            );
        } else {
            return (<i>{this.props.missing_message}</i>)
        }
    }

    render() {
        return (
            <div className="text-left w100 sample-item">
                <div>
                    <label>Select a beer</label>
                    <a className="remove-sample float-right" onClick={this.remove}>x</a>
                    {this.form_input()}
                </div>

                {this.options()}
            </div>
        );
    }
}

export default SimpleSampleInput